import { createContext, useContext, useState, useCallback, useMemo } from "react";

// In-memory user context. No localStorage / sessionStorage / cookies — refresh = re-enter email.
const UserCtx = createContext(null);

export function UserProvider({ children }) {
  const [user, setUserState] = useState(null);

  const setUser = useCallback((u) => setUserState(u), []);
  const patchUser = useCallback((patch) => {
    setUserState((prev) => (prev ? { ...prev, ...patch } : prev));
  }, []);
  const clearUser = useCallback(() => {
    setUserState(null);
  }, []);

  const value = useMemo(
    () => ({
      user,
      setUser,
      patchUser,
      clearUser,
    }),
    [user, setUser, patchUser, clearUser]
  );

  return <UserCtx.Provider value={value}>{children}</UserCtx.Provider>;
}

export function useUser() {
  const ctx = useContext(UserCtx);
  if (!ctx) throw new Error("useUser must be used inside <UserProvider>");
  return ctx;
}
